module.exports = __webpack_public_path__ + "img/step3.93530637.png";